<script setup>
import { formatCurrency } from "@/utils/formatCurrency"
import { useCampaignImages } from "@/composables/useCampaignImages.js"

const props = defineProps({
  campaign: {
    type: Object,
    required: true,
  },
})

const { campaignImages, logoImage, getImageUrl } = useCampaignImages()
campaignImages.value = props.campaign.images
</script>

<template>
  <dl>
    <div class="flex gap-5 relative">
      <dd class="flex justify-center items-center">
        <router-link
          :to="{
            name: 'Campaign',
            params: { id: campaign.id },
          }"
          draggable="false"
        >
          <figure class="h-16 w-32 flex justify-center items-center">
            <img
              v-if="campaignImages?.length > 0"
              :src="
                campaignImages[0].conversions.filter(
                  image => image.conversion === '300x200'
                )[0].storageUrl
              "
              class="object-cover w-full h-full rounded-md block border border-base-100 dark:border-transparent"
            />
            <img
              v-else-if="logoImage"
              :src="getImageUrl(logoImage, 'md')"
              :alt="`${campaign.name} logo`"
              class="h-full w-auto object-contain"
            />
          </figure>
        </router-link>
      </dd>
      <dd class="flex flex-col justify-center">
        <div class="flex h-10 items-center pb-2">
          <p
            class="text-wrap break-words whitespace-normal max-w-xs !leading-[1.2em] font-normal line-clamp-2"
          >
            {{ campaign.name }}
          </p>
        </div>

        <p class="text-xxs text-neutral-content/60 !leading-[1em]">
          Commission
        </p>
        <p class="commission-value font-semibold text-lg">
          {{ formatCurrency(campaign.payout) }}
        </p>
      </dd>
    </div>
  </dl>
</template>

<style scoped></style>
